import { render, staticRenderFns } from "./liveplayer.vue?vue&type=template&id=636c54f0&scoped=true&"
import script from "./liveplayer.vue?vue&type=script&lang=js&"
export * from "./liveplayer.vue?vue&type=script&lang=js&"
import style0 from "./liveplayer.vue?vue&type=style&index=0&id=636c54f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c54f0",
  null
  
)

export default component.exports